import api from './index'
import { axios } from '@/utils/request'
import qs from 'qs'

export function addProjectUser (params) {
  return axios({
    url: api.AddProjectUser,
    method: 'post',
    params: params
  })
}

export function deleteProjectUser (member_uid, item_id) {
  return axios({
    url: api.DeleteProjectUser + '/' + member_uid + '/' + item_id,
    method: 'delete'
  })
}

export function getProjectUserList (params) {
  return axios({
    url: api.ProjectUserList,
    method: 'get',
    params: params
  })
}
